/** @module components/Form/FormGroupGeolocationWithFallback */

import { useState } from 'react';
import FormGroupAddressSearchGoogle from './form-group-address-search-google';
import FormGroupGeolocation from './form-group-geolocation';

const STORAGE_KEY = 'address-search-quota-exceeded';

type Props = {
  address: string;
  onCoordinates: FormOnCoordinates;
  onAddress: (v: string) => void;
};

const FormGroupGeolocationWithFallback = ({ address, onCoordinates, onAddress }: Props) => {
  const [useGeoGratis, setUseGeoGratis] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === 'true',
  );

  if (useGeoGratis) {
    return (
      <FormGroupGeolocation
        address={address}
        onCoordinates={onCoordinates}
        onAddress={onAddress}
      />
    );
  }

  return (
    <FormGroupAddressSearchGoogle
      address={address}
      onCoordinates={onCoordinates}
      onAddress={onAddress}
      onQuotaError={() => {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        setUseGeoGratis(true);
      }}
    />
  );
};

export default FormGroupGeolocationWithFallback;
